import { Badge } from '@givebutter/primitives/badge';
import { faLink } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as AddMemberCollapsible from 'assets/js/pages/campaign-settings/campaign-members/AddMemberCollapsible';
import { useAddMemberCollapsibleStore } from 'assets/js/pages/campaign-settings/campaign-members/useAddMemberCollapsibleStore';
import * as Input from 'components/input';
import { useCurrentCampaign } from 'customHooks/useCurrentCampaign';

const AddMemberLinkCollapsible = () => {
    const { data: campaign } = useCurrentCampaign();
    const { collapsibleCard, setCollapsibleCard } = useAddMemberCollapsibleStore();
    const joinCampaignUrl = `${campaign?.url}/join`;

    return (
        <AddMemberCollapsible.Root
            open={collapsibleCard === 'link'}
            onOpenChange={() => setCollapsibleCard('link')}
        >
            <AddMemberCollapsible.Trigger>
                <AddMemberCollapsible.TriggerLeft>
                    <FontAwesomeIcon size={'lg'} className={'text-blue-500'} icon={faLink} />
                </AddMemberCollapsible.TriggerLeft>
                <AddMemberCollapsible.TriggerRight>
                    <div className={'flex items-center justify-between'}>
                        <div className={'flex items-center gap-2'}>
                            <p className={'text-sm font-medium'}>Share link</p>
                            <Badge color="success" className="hidden sm:block">
                                Recommended
                            </Badge>
                        </div>
                        <AddMemberCollapsible.ExpandIcon />
                    </div>
                </AddMemberCollapsible.TriggerRight>
            </AddMemberCollapsible.Trigger>
            <AddMemberCollapsible.Content>
                <div className={'flex flex-col gap-2'}>
                    <p className={'text-sm'}>
                        Send this link to your team in a Facebook Group, GroupMe, ListServ, etc.
                    </p>
                    <Input.Root>
                        <Input.Form readOnly={true} value={joinCampaignUrl} />
                        <Input.CopyButton text={joinCampaignUrl} inPortal={true} />
                    </Input.Root>
                </div>
            </AddMemberCollapsible.Content>
        </AddMemberCollapsible.Root>
    );
};

export { AddMemberLinkCollapsible };
